import React from "react";
import { formatCPF, formatTelefone } from "../../../../../../../function/utilis/function";
import styles from "./GroupContato.module.css";

/** Um par rótulo/valor. Mostra um placeholder em itálico quando o dado não veio preenchido. */
function Campo({ rotulo, valor, largo }) {
  const vazio = valor === null || valor === undefined || valor === "";
  return (
    <div className={`${styles.campo} ${largo ? styles.campoLargo : ""}`}>
      <span className={styles.rotulo}>{rotulo}</span>
      <span className={vazio ? styles.valorVazio : styles.valor}>{vazio ? "Não informado" : valor}</span>
    </div>
  );
}

export function GroupContato({ info }) {
  return (
    <div className={styles.painel}>
      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Contato</h4>
        <div className={styles.grade}>
          <Campo rotulo="Contato ID" valor={info.contatoId} />
          <Campo rotulo="CPF" valor={info.cpf ? formatCPF(info.cpf) : null} />
          <Campo rotulo="Nome" valor={info.nomeCliente} largo />
          <Campo rotulo="Telefone" valor={info.telefone ? formatTelefone(info.telefone) : null} />
          <Campo rotulo="Email" valor={info.email} largo />
        </div>
      </div>
    </div>
  );
}

export default GroupContato;
